export const manifestLocales = {
  spacer: {
    previewImageAlt: {
      en: 'spacer widget',
      he: 'ריווח'
    }
  }
};
